import styled from 'styled-components';
const VerticalSpace = styled.div `
  width: 100%;
  height: ${(props) => `${props.space}px`};
`;
export default VerticalSpace;
//# sourceMappingURL=index.js.map